import CoachCardVersion3 from './coach-card-version-3'

export default CoachCardVersion3
